<template>
  <div id="app">
    <div class="content">

      <Slide class="side-bar">
        <router-link :to="{ name: $route.name, params: {language: 'de'} }">
          <span>de</span>
        </router-link>
        <router-link :to="{ name: $route.name, params: {language: 'en'} }">
          <span>en</span>
        </router-link>

        <router-link :to="{ name: 'home', params: {language: $route.params.language }}">
          <span>{{ $t("message.navi.home") }}</span>
        </router-link>
        <router-link :to="{ name: 'contact', params: {language: $route.params.language }}">
          <span>{{ $t("message.navi.contact") }}</span>
        </router-link>
        <router-link :to="{ name: 'skills', params: {language: $route.params.language }}">
          <span>{{ $t("message.navi.skills") }}</span>
        </router-link>
      </Slide>

      <router-view></router-view>
    </div>

    <footer>
      <div class="content">
        <h3>{{ $t("message.blog.header") }}</h3>
        <a href="https://blog.mayflower.de/author/Micha">{{ $t("message.blog.link1") }}</a><br>
        <a href="http://triebawerker.blogspot.de">{{ $t("message.blog.link2") }}</a>

        <h3>{{ $t("message.contact.header") }}</h3>
          <p>
            {{ $t("message.contact.contact") }}<br>
            <a href="mailto:micha@triebawerker.de">micha@triebawerker.de</a>
          </p>

        <h3>{{ $t("message.responsible.header") }}</h3>
          <p>
            {{ $t("message.responsible.contact") }}<br>
            <a href="mailto:micha@triebawerker.de">micha@triebawerker.de</a>
          </p>
        <p>Built with vuejs</p>
      </div>

    </footer>
  </div>

</template>
<script>
import { Slide } from 'vue-burger-menu'
export default {
  components: {
    Slide
  }
}

</script>

<style lang="scss">

@media screen and (min-width: 320px) {
  .content {
    padding: 0 20px 0 20px;
  }
}

@media screen and (min-width: 768px) {
  .content {
    width: 80%;
  }
}

@media screen and (min-width: 1024px) {
  .content {
    width: 60%;
  }
}


@media screen and (min-width: 1200px) {
  .content {
    width: 750px;
  }
}
body {
  margin: 0;
}

footer {
  background-color: black;
  padding: 30px 0 20px 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 16pt;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
.content {
  margin: auto;
}

.orange {
  color: #e46700;
}

h1, h2, h3 {
  font-weight: normal;
  margin-top: 30px;
  color: #e46700;
}

ul {
  margin-left: 40px;
  list-style-type: square;
  padding: 0;
}

li {
  padding-bottom: 10px;
}

footer a {
  color: white;
}

footer p {
  color: white;
}

.bm-item-list {
  font-size: 24pt;
}

</style>
